import { Modal } from 'UIPackage/ModalModule/components/Modal';
import { Button } from 'UIPackage/MainModule/components/Button';
import { ModalHeader } from 'UIPackage/ModalModule/components/ModalHeader';
import { ModalBody } from 'UIPackage/ModalModule/components/ModalBody';
import { ModalActions } from 'UIPackage/ModalModule/components/ModalActions';

import styles from './FeedbackAgreementModal.module.scss';

interface IFeedbackAgreementModalProps {
  visible: boolean;
  onClose: () => void;
}

export const FeedbackAgreementModal = ({ visible, onClose }: IFeedbackAgreementModalProps) => (
  <Modal modalBodyClassName={styles.ModalBody} visible={visible} onClose={onClose}>
    <ModalHeader title="Политика обработки персональных данных" />
    <ModalBody border="bottom">
      <div className={styles.Content}>
        <span className={styles.SubTitle}>1. Общие положения</span>
        <p>
          1.1. Настоящая Политика в отношении обработки персональных данных (далее – Политика) составлена в соответствии
          с пунктом 2 статьи 18.1 Федерального закона «О персональных данных» № 152-ФЗ от 27 июля 2006 г., а также иными
          нормативными правовыми актами Российской Федерации в области защиты и обработки персональных данных и
          разработана в целях обеспечения защиты прав и свобод субъекта персональных данных при обработке его
          персональных данных, в том числе защиты прав на неприкосновенность частной жизни, личную и семейную тайну
          (далее – данные), которые оператор системы (далее – Оператор) может получить от субъекта персональных данных
          от пользователя сети Интернет (далее – Пользователь) во время использования им Федеральной государственной
          информационной системы «Единый реестр проверок» (далее – ФГИС ЕРП)
        </p>
        <p>
          1.2. Оператор обеспечивает защиту обрабатываемых персональных данных от несанкционированного доступа и
          разглашения, неправомерного использования или утраты в соответствии с требованиями Федерального закона от 27
          июля 2006 г. № 152-ФЗ «О персональных данных».
        </p>
        <p>
          1.3. Оператор вправе вносить изменения в настоящую Политику. При внесении изменений в заголовке заголовке
          Политики указывается дата последнего обновления редакции. Новая редакция Политики вступает в силу с момента ее
          размещения на сайте, если иное не предусмотрено новой редакцией Политики.
        </p>
        <span className={styles.SubTitle}>2. Термины и принятые сокращения</span>
        Персональные данные – любая информация, относящаяся к прямо или косвенно определенному, или определяемому
        физическому лицу (субъекту персональных данных). Обработка персональных данных – любое действие (операция) или
        совокупность действий (операций), совершаемых с использованием средств автоматизации или без использования таких
        средств с персональными данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение
        (обновление, изменение), извлечение, использование, передачу (распространение, предоставление, доступ),
        обезличивание, блокирование, удаление, уничтожение персональных данных. Автоматизированная обработка
        персональных данных – обработка персональных данных с помощью средств вычислительной техники. Персональные
        данные, сделанные общедоступными субъектом персональных данных, – персональные данные, доступ неограниченного
        круга лиц к которым предоставлен субъектом персональных данных либо по его просьбе. Распространение персональных
        данных - действия, направленные на раскрытие персональных данных неопределенному кругу лиц; Предоставление
        персональных данных - действия, направленные на раскрытие персональных данных определенному лицу или
        определенному кругу лиц; Блокирование персональных данных – временное прекращение обработки персональных данных
        (за исключением случаев, если обработка необходима для уточнения персональных данных). Обезличивание
        персональных данных - действия, в результате которых становится невозможным без использования дополнительной
        информации определить принадлежность персональных данных конкретному субъекту персональных данных; Уничтожение
        персональных данных – действия, в результате которых становится невозможным восстановить содержание персональных
        данных в информационной системе персональных данных и (или) в результате которых уничтожаются материальные
        носители персональных данных. Оператор – организация, самостоятельно или совместно с другими лицами организующая
        обработку персональных данных, а также определяющая цели обработки персональных данных, подлежащих обработке,
        действия (операции), совершаемые с персональными данными.
        <span className={styles.SubTitle}>3. Обработка персональных данных</span>
        <p>3.1. Получение персональных данных.</p>
        <p>
          3.1.1. Все персональные данные следует получать от самого субъекта. Если персональные данные субъекта можно
          получить только у третьей стороны, то субъект должен быть уведомлен об этом или от него должно быть получено
          согласие.
        </p>
        <p>
          3.1.2. Оператор должен сообщить субъекту о целях, предполагаемых источниках и способах получения персональных
          данных, характере подлежащих получению персональных данных, перечне действий с персональными данными, сроке, в
          течение которого действует согласие, и порядке его отзыва, а также о последствиях отказа субъекта дать
          письменное согласие на их получение.
        </p>
        <p>3.2. Обработка персональных данных.</p>
        <p>
          3.2.1. Обработка персональных данных осуществляется:
          <ul>
            <li>– с согласия субъекта персональных данных на обработку его персональных данных;</li>
            <li>
              – в случаях, когда обработка персональных данных необходима для осуществления и выполнения возложенных
              законодательством РФ функций, полномочий и обязанностей;
            </li>
            <li>
              – в случаях, когда осуществляется обработка персональных данных, доступ неограниченного круга лиц к
              которым предоставлен субъектом персональных данных либо по его просьбе (далее – персональные данные,
              сделанные общедоступными субъектом персональных данных).
            </li>
          </ul>
        </p>
        <p>
          3.2.2. Цели обработки персональных данных:
          <ul>
            <li>
              – для связи с пользователем, в связи с заполнением формы обратной связи на сайте, в том числе направление
              уведомлений, запросов и информации, касающихся использования ФГИС ЕРП;
            </li>
            <li>
              - обезличивания персональных данных для получения обезличенных статистических данных, которые передаются
              третьему лицу для проведения исследований, выполнения работ.
            </li>
          </ul>
        </p>
        <p>
          3.2.3. Категории субъектов персональных данных:
          <ul>
            <li>– физические лица – отправляющие запрос по работе с системой с помощью подсистемы «Обратная связь»;</li>
            <li>– физические лица – осуществляющие работу с Закрытой частью ФГИС ЕРНКМ(ЕРП)</li>
          </ul>
        </p>
        <p>
          3.2.4. Персональные данные, обрабатываемые Оператором:
          <ul>
            <li>– данные, полученные от пользователей ФГИС ЕРНКМ(ЕРП).</li>
          </ul>
        </p>
        <p>
          3.2.5. Обработка персональных данных ведется:
          <ul>
            <li>– с использованием средств автоматизации;</li>
            <li>– без использования средств автоматизации.</li>
          </ul>
        </p>
        <p>3.3. Хранение персональных данных.</p>
        <p>
          3.3.1. Персональные данные субъектов могут быть получены, проходить дальнейшую обработку и передаваться на
          хранение в электронном виде.
        </p>
        <p>
          3.3.3. Обработке подлежат только персональные данные, которые отвечают целям их обработки. Содержание и объем
          обрабатываемых персональных данных должны соответствовать заявленным целям обработки. Персональные данные
          субъектов, обрабатываемые с использованием средств автоматизации в разных целях, хранятся в разных папках.
        </p>
        <p>
          3.3.4. Не допускается хранение и размещение документов, содержащих персональных данных, в открытых электронных
          каталогах (файлообменниках).
        </p>
        <p>
          3.3.5. Хранение персональных данных в форме, позволяющей определить субъекта персональных данных,
          осуществляется не дольше, чем этого требуют цели их обработки, и они подлежат уничтожению по достижении целей
          обработки или в случае утраты необходимости в их достижении.
        </p>
        <p>
          3.3.6. При осуществлении хранения персональных данных оператор персональных данных обязан использовать базы
          данных, находящиеся на территории Российской Федерации, в соответствии с ч. 5 ст. 18 Федерального закона
          &quot;О персональных данных&quot;.
        </p>
        <p>3.4. Уничтожение персональных данных.</p>
        <p>
          3.4.2. Персональные данные на электронных носителях уничтожаются путем стирания или форматирования носителя.
        </p>
        <p>3.4.3. Факт уничтожения персональных данных подтверждается документально актом об уничтожении носителей.</p>
        <p>3.5. Передача персональных данных.</p>
        <p>
          3.5.1. Оператор передает персональные данные третьим лицам в следующих случаях:
          <ul>
            <li>– субъект выразил свое согласие на такие действия;</li>
            <li>
              – передача предусмотрена российским или иным применимым законодательством в рамках установленной
              законодательством процедуры.
            </li>
          </ul>
        </p>
        <span className={styles.SubTitle}>4. Основные права субъекта персональных данных и обязанности Оператора</span>
        <p>
          4.1. Основные права субъекта персональных данных. Субъект имеет право на доступ к его персональным данным и
          следующим сведениям:
          <ul>
            <li>– подтверждение факта обработки персональных данных Оператором;</li>
            <li>– правовые основания и цели обработки персональных данных;</li>
            <li>– цели и применяемые Оператором способы обработки персональных данных;</li>
            <li>
              – наименование и место нахождения Оператора, сведения о лицах (за исключением работников Оператора),
              которые имеют доступ к персональным данным или которым могут быть раскрыты персональные данные на
              основании договора с Оператором или на основании федерального закона;
            </li>
            <li>– сроки обработки персональных данных, в том числе сроки их хранения;</li>
            <li>– порядок осуществления субъектом персональных данных прав, предусмотренных Федеральным законом;</li>
            <li>
              – наименование или фамилия, имя, отчество и адрес лица, осуществляющего обработку персональных данных по
              поручению Оператора, если обработка поручена или будет поручена такому лицу;
            </li>
            <li>– обращение к Оператору и направление ему запросов;</li>
            <li>– обжалование действий или бездействия Оператора.</li>
          </ul>
        </p>
        <p>
          4.2. Обязанности Оператора. Оператор обязан:
          <ul>
            <li>– при сборе персональных данных предоставить информацию об обработке персональных данных;</li>
            <li>
              – в случаях если персональные данные были получены не от субъекта персональных данных, уведомить субъекта;
            </li>
            <li>– при отказе в предоставлении персональных данных субъекту разъясняются последствия такого отказа;</li>
            <li>
              – опубликовать или иным образом обеспечить неограниченный доступ к документу, определяющему его политику в
              отношении обработки персональных данных, к сведениям о реализуемых требованиях к защите персональных
              данных;
            </li>
            <li>
              – принимать необходимые правовые, организационные и технические меры или обеспечивать их принятие для
              защиты персональных данных от данных от неправомерного или случайного доступа к ним, уничтожения,
              изменения, блокирования, копирования, предоставления, распространения персональных данных, а также от иных
              неправомерных действий в отношении персональных данных;
            </li>
            <li>
              – давать ответы на запросы и обращения субъектов персональных данных, их представителей и уполномоченного
              органа по защите прав субъектов персональных данных.
            </li>
          </ul>
        </p>
      </div>
    </ModalBody>
    <ModalActions>
      <Button color="default" size="medium" text="Закрыть" type="button" onClick={onClose} />
    </ModalActions>
  </Modal>
);
